import { LangType, isHtm } from "./const";
import { i18n } from "../main";
export const isInIntlBrowser = /intlbrowser/i.test(navigator.userAgent);
export const IsTest = location.origin.includes("test") || location.origin.includes('localhost') || location.origin.includes('192.168.255.10');
// detect navigator share
// todo: files && other
export function canUseNavigatorShare(text: string) {
  return navigator.canShare && navigator.canShare({ text });
}

export function dataURLtoFile(dataurl:any, filename:string) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return {
    file: new File([u8arr], filename, { type: mime }),
    blob: new Blob([u8arr], { type: mime }),
  };
}

export enum LoginErrorCode {
  ACCOUNT_NOT_VALID = 2001,
  ACCOUNT_NOT_EXIST = 2200,
  ACCOUNT_NOT_RIGHT = 2002,
  PASSWORD_EMPTY = 2108,
  PASSWORD_NOT_SET = 808099001,
}

export const getErrMessage = (code: LoginErrorCode) => {
  const map = {
    [LoginErrorCode.ACCOUNT_NOT_VALID]: i18n.t('account_not_exist'),
    [LoginErrorCode.ACCOUNT_NOT_EXIST]: i18n.t('account_not_exist'),
    [LoginErrorCode.PASSWORD_EMPTY]: i18n.t('password_empty'),
    [LoginErrorCode.ACCOUNT_NOT_RIGHT]: i18n.t('pls_input_info'),
    [LoginErrorCode.PASSWORD_NOT_SET]: i18n.t('pls_input_info'),

  }
  return map[code] ?? i18n.t('error');
}

export function getLang(): LangType {
  // 港澳台
  if (isHtm) return 'zh';
  const hostnameConfig: Record<string, LangType> = {
    'nikke-jp.com': 'ja',
    'nikke-kr.com': 'ko',
    'nikke-en.com': 'en',
    'nikke-sea.com': 'th',
  };
  const target = Object.keys(hostnameConfig).find((key) =>
    location.hostname.toLowerCase().includes(key)
  );
  if (!target) return 'en';
  return hostnameConfig[target] || 'en';
}

export function switchLang(lang: LangType): void {
  if (isHtm) {
    // todo 跳转确定
    location.href = "https://nikke.hotcool.tw/islandexploration/";
    return;
  }
  const prodMap = {
    ko: 'kr',
    ja: 'jp',
    en: 'en',
    th: 'sea',
  };
  location.href = location.href.replace(
    `nikke-${(prodMap[getLang() as keyof typeof prodMap] || 'en').toLowerCase()}`,
    `nikke-${(prodMap[lang as keyof typeof prodMap ] || 'en').toLowerCase()}`
  );
}
export function urlparamsToObject() {
  const res: Record<string, string> = {};
  const urlparams = new URLSearchParams(location.search);
  urlparams.forEach((val, key) => {
    res[key] = val;
  });
  return res;
}

export function getSpecialBrowserType() {
  const uaTester = (regs: RegExp[]) => Boolean(regs.find((reg) => reg.test(navigator.userAgent)));
  if (uaTester([/fbav/i, /fban/i])) {
    return 'facebook';
  }
  if (uaTester([/naver/i, /fban/i])) {
    return 'naver';
  }
  if (uaTester([/bytelo/i, /bytedance/i])) {
    return 'tictok';
  }
  if (uaTester([/microm/i, /wechat/i])) {
    return 'wechat';
  }
  if (uaTester([/vivobrowser/i, /vivo/i])) {
    return 'vivo';
  }
  if (uaTester([/mibrowser/i, /xiaomi/i, /miui/i])) {
    return 'mi';
  }
  if (uaTester([/discord/i])) {
    return 'discord';
  }
  if (uaTester([/kakao/i, /kakaotalk/i])) {
    return 'kakao';
  }
  if (uaTester([/line/i])) {
    return 'line';
  }
  if (uaTester([/instagram/i])) {
    return 'ins';
  }
  return '';
}

export function appendScript(script: string) {
	return new Promise((resolve, reject) => {
		const head = document.getElementsByTagName("head")[0];
		const wsScript = document.createElement("script");
		wsScript.type = "text/javascript";
		wsScript.src = script;
	
		head.appendChild(wsScript);
		const scriptLoaded = (e: Event) => {
			wsScript.removeEventListener("load", scriptLoaded);
			resolve(e);
		};
		const scriptLoadFailed = (e: Event) => {
			wsScript.removeEventListener("error", scriptLoadFailed);
			reject(e);
		};
		wsScript.addEventListener("load", scriptLoaded);
		wsScript.addEventListener("error", scriptLoadFailed);
		wsScript.addEventListener("abort", scriptLoadFailed);
	});
}

export function appendLink(script: string) {
	return new Promise((resolve, reject) => {
		const head = document.getElementsByTagName("head")[0];
		const wsScript = document.createElement("link");
		wsScript.rel = "stylesheet";
		wsScript.href = script;
	
		head.appendChild(wsScript);
		const scriptLoaded = (e: Event) => {
			wsScript.removeEventListener("load", scriptLoaded);
			resolve(e);
		};
		const scriptLoadFailed = (e: Event) => {
			wsScript.removeEventListener("error", scriptLoadFailed);
			reject(e);
		};
		wsScript.addEventListener("load", scriptLoaded);
		wsScript.addEventListener("error", scriptLoadFailed);
		wsScript.addEventListener("abort", scriptLoadFailed);
	});
}